module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/1200_630_shizen-e47d86def2d0694e67b8a9727b3e8208.jpg";